<div class="border rounded p-3 bg-white">
    <h5 class="mb-3 text-primary">Votos del usuario</h5>
    <div class="table-responsive" style="height: 30%; overflow-y: auto; ">
        <table class="table table-bordered align-middle table-hover table-sm">
            <thead class="table-primary text-center">
                <tr>
                    <th>Voto</th>
                    <th>Descripción</th>
                    <th>Empleado</th>
                    <th>Periodo</th>
    
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let voto of votes" class="text-center form-label-sm">
                    <td>{{ voto.numero }}</td>
                    <td>{{ voto.descripcion }}</td>
                    <td>{{ voto.empleado }}</td>
                    <td>{{ voto.periodo }}</td>
    
                </tr>
            </tbody>
        </table>
    </div>
</div>

